module.exports = __webpack_public_path__ + "static/media/work-image.63490423.svg";